import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import StatusChip from 'ui/StatusChip';
import SimpleTable from 'ui/Table';
import DateFormater from 'ui/formats/Date';

import {
    isAzureConnector,
    isCompleteAzureConnector,
    isVerifiedAzureConnector,
    isActiveDirectory,
} from '../Consts';

const styles = theme => ({
    label: {
        fontWeight: 500,
    },
    statusTable: {
        margin: `${theme.spacing(2)}px 0`,
    },
});

export function ConnectorStatusChip({ connector }) {
    if (isAzureConnector(connector)) {
        if (!isVerifiedAzureConnector(connector)) {
            return <StatusChip label="Not verified" />;
        }
        if (!isCompleteAzureConnector(connector)) {
            return <StatusChip label="Setup incomplete" />;
        }
    }

    if (connector.status === 'waiting') {
        return <StatusChip label="Waiting for connection" />;
    } else if (!connector.extra.is_available && !isActiveDirectory(connector)) {
        return <StatusChip label="Sync in progress" variant="active" />;
    }
    return <StatusChip label="Connected" variant="active" />;
}

const _ConnectorStatusTable = ({ connector, classes }) => {
    const options = {
        columns: [
            {
                format: () => <ConnectorStatusChip connector={connector} />,
                styles: {
                    align: 'left',
                    width: '25%',
                },
            },
            null,
            null,
            {
                format: value => <DateFormater value={value} />,
            },
        ],
        header: ['Status', 'Sync Users', 'Sync Groups', 'Last Sync'],
    };
    const isWaiting = connector.status === 'waiting';
    const data = isWaiting
        ? [[connector.status, '', '', '']]
        : [
              [
                  connector.status,
                  connector.accounts_count,
                  connector.groups_count,
                  connector.last_sync_date,
              ],
          ];
    return (
        <div className={classes.statusTable}>
            <Typography component="div" className={classes.label}>
                Connector Status
            </Typography>
            <SimpleTable data={data} options={options} />
        </div>
    );
};

export const ConnectorStatusTable = withStyles(styles)(_ConnectorStatusTable);
